/**
 * Ryan O'Dowd
 * 2024-10-30
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      color: colors.white,
      fontSize: globalScale * 16,
      textAlign: 'center',
    },
  };
};

export default getStyles;
